// ZaviaRatesService — capa de integración FUTURA con la API oficial de tarifas de Zavia ERP.
// HOY no existe acceso autorizado a tarifas: getDailyRates devuelve null y el calendario
// NO muestra precios (nunca $0 ni datos simulados). La selección de fechas funciona igual.
//
// Cuando Zavia entregue la documentación oficial (API / widget / endpoint):
// - Si es pública: llamar aquí directamente.
// - Si requiere credenciales: implementar en /app/backend/server.py un endpoint
//   GET /api/rates?from=&to=&adults=&children=&lang= y consumirlo desde aquí.
//   Las credenciales NUNCA van en el navegador.
//
// Respuesta normalizada esperada por el calendario (estructura interna de referencia):
// { "2026-08-23": { date: "2026-08-23", available: true, rate: 975, currency: "MXN" } }

export const ZAVIA_CONFIG = {
    hotelId: "puntapalmeras",
    currency: "MXN",
    timezone: "America/Mazatlan", // zona horaria local del hotel
    childAgesEnabled: false, // activar cuando Zavia/hotel confirmen reglas de edad
    childAgeRange: { min: 0, max: 12 }, // configurable, NO oficial aún
};

const cache = new Map();
let inflight = null;

export async function getDailyRates({ from, to, adults, children, lang }) {
    const key = `${from}|${to}|${adults}|${children}|${lang}`;
    if (cache.has(key)) return cache.get(key);
    if (inflight) inflight.aborted = true;
    const ticket = { aborted: false };
    inflight = ticket;
    // Sin API oficial: no hay tarifas que mostrar.
    const result = null;
    if (!ticket.aborted) cache.set(key, result);
    return result;
}
